import React from 'react'
import Select from '../../../commons/Select'
import {
  allowNumericOnly,
  numberWithCommas,
  numberAddCommas,
  presenceErrorClass,
} from 'servos/formValidations'

const frequencyOptions = [
  { value: 'yearly', label: 'Annually' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'fortnightly', label: 'Fortnightly' },
  { value: 'weekly', label: 'Weekly' },
]

class InputBox extends React.Component {
  render() {
    const {
      amount,
      frequency,
      type,
      handleFrequency,
      handleAmount,
      errorMessage,
      labelClass,
      label,
      inputMode
    } = this.props

    return (
      <div className="form-group">
        <label className={labelClass}>{label}</label>
        <div className="form-row">
          <div className="col-6 col-sm-4">
            <div className="input-group">
              <div className="input-group-prepend">
                <div className={`input-group-text ${presenceErrorClass(errorMessage)}`}>
                  $
                </div>
              </div>
              <input id={type}
                onKeyPress={allowNumericOnly}
                onKeyUp={numberWithCommas}
                value={numberAddCommas(amount)}
                className={`form-control ${presenceErrorClass(errorMessage)} ${type}`}
                onChange={handleAmount}
                inputMode={ inputMode ? inputMode : 'text' }
              />
              <div className="invalid-feedback">
                { errorMessage }
              </div>
            </div>
          </div>
          <div className="col-6 col-sm-4">
            <Select
              defaultValue={ frequency || frequencyOptions[0].value }
              onChange={handleFrequency}
              options={frequencyOptions}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default InputBox;
